module.exports = __webpack_public_path__ + "img/1@2x.a4bb514a.webp";